import { Input } from '@nike/frame-component-library';
import PropTypes from 'prop-types';
import React from 'react';

import { CustomPanel } from '../../../reusable';

/* display form contents...
 * if adding
 * if there exists an error on any of the fields that we validate
 * note: we use !! to force consideration of prop as bool
 */
const calculateIsOpen = (properties) => (properties.adding
  || !!properties.formErrors.name || !!properties.formErrors.storeNumber
  || !!properties.formErrors.country || !!properties.formErrors.storeChannel);

class Address extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: calculateIsOpen(props),
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.formErrors !== this.props.formErrors) {
      if (this.state.isOpen) { return; }
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ isOpen: calculateIsOpen(this.props) });
    }
  }

  panelToggle = () => this.setState((prevState) => ({ isOpen: !prevState.isOpen }));

  render = () => (
    <CustomPanel
      isOpen={this.state.isOpen}
      label="Address"
      onClick={this.panelToggle}
    >
      <article className="ncss-col-sm-6 va-sm-t">
        <Input
          errorMessage={this.props.formErrors.address1}
          isDisabled={this.props.userIsReadOnly}
          label="Address 1"
          value={this.props.formData?.address?.address1 || ''}
          onChange={({ target: { value } }) => this.props.updateFormData('address', { ...(this.props.formData.address || {}), address1: value })}
        />
      </article>
      <article className="ncss-col-sm-6 va-sm-t">
        <Input
          errorMessage={this.props.formErrors.address2}
          isDisabled={this.props.userIsReadOnly}
          label="Address 2"
          value={this.props.formData?.address?.address2 || ''}
          onChange={({ target: { value } }) => this.props.updateFormData('address', { ...(this.props.formData.address || {}), address2: value })}
        />
      </article>
      <article className="ncss-col-sm-6 va-sm-t">
        <Input
          errorMessage={this.props.formErrors.address3}
          isDisabled={this.props.userIsReadOnly}
          label="Address 3"
          value={this.props.formData?.address?.address3 || ''}
          onChange={({ target: { value } }) => this.props.updateFormData('address', { ...(this.props.formData.address || {}), address3: value })}
        />
      </article>
      <article className="ncss-col-sm-6 va-sm-t">
        <Input
          errorMessage={this.props.formErrors.city}
          isDisabled={this.props.userIsReadOnly}
          label="City"
          value={this.props.formData?.address?.city || ''}
          onChange={({ target: { value } }) => this.props.updateFormData('address', { ...(this.props.formData.address || {}), city: value })}
        />
      </article>
      <article className="ncss-col-sm-6 va-sm-t">
        <Input
          isDisabled
          errorMessage={this.props.formErrors.country}
          label="Country"
          value={this.props.formData?.address?.country || ''}
          onChange={({ target: { value } }) => this.props.updateFormData('address', { ...(this.props.formData.address || {}), country: value })}
        />
      </article>
      <article className="ncss-col-sm-6 va-sm-t">
        <Input
          errorMessage={this.props.formErrors.postalCode}
          isDisabled={this.props.userIsReadOnly}
          label="Postal Code"
          value={this.props.formData?.address?.postalCode || ''}
          onChange={({ target: { value } }) => this.props.updateFormData('address', { ...(this.props.formData.address || {}), postalCode: value })}
        />
      </article>
      <article className="ncss-col-sm-6 va-sm-t">
        <Input
          errorMessage={this.props.formErrors.state}
          isDisabled={this.props.userIsReadOnly}
          label="State"
          value={this.props.formData?.address?.state || ''}
          onChange={({ target: { value } }) => this.props.updateFormData('address', { ...(this.props.formData.address || {}), state: value })}
        />
      </article>
    </CustomPanel>
  );
}

Address.propTypes = {
  // ignoring eslint even though the prop is used
  // eslint-disable-next-line react/no-unused-prop-types
  adding: PropTypes.bool.isRequired,
  formData: PropTypes.shape().isRequired,
  formErrors: PropTypes.shape().isRequired,
  updateFormData: PropTypes.func.isRequired,
  userIsReadOnly: PropTypes.bool.isRequired,
};

export default Address;
